import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.index-of";
import React from 'react'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import pick from 'lodash/pick'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get';
import classNames from 'classnames';
import { Heading, Li, Link, List, Type } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import style from '../html-to-nds.module.less';

var safeUrl = function safeUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var onSafe = arguments.length > 1 ? arguments[1] : undefined;
  var onUnsafe = arguments.length > 2 ? arguments[2] : undefined;
  return String(url).indexOf('https://') === 0 ? onSafe() : onUnsafe();
};

var NDSLib = {
  ol: function ol(node, children) {
    return /*#__PURE__*/React.createElement(List, {
      ordered: true
    }, children);
  },
  ul: function ul(node, children) {
    return /*#__PURE__*/React.createElement(List, null, children);
  },
  li: function li(node, children) {
    return /*#__PURE__*/React.createElement(Li, null, children);
  },
  h1: function h1(node, children) {
    return /*#__PURE__*/React.createElement(Heading, {
      level: 1
    }, children);
  },
  h2: function h2(node, children) {
    return /*#__PURE__*/React.createElement(Heading, {
      level: 2
    }, children);
  },
  h3: function h3(node, children) {
    return /*#__PURE__*/React.createElement(Heading, {
      level: 3
    }, children);
  },
  h4: function h4(node, children) {
    return /*#__PURE__*/React.createElement(Heading, {
      level: 4
    }, children);
  },
  h5: function h5(node, children) {
    return /*#__PURE__*/React.createElement(Heading, {
      level: 5
    }, children);
  },
  h6: function h6(node, children) {
    return /*#__PURE__*/React.createElement(Type, {
      component: "h6",
      size: "2",
      bold: true
    }, children);
  },
  p: function p(node, children) {
    return /*#__PURE__*/React.createElement(Type, null, children);
  },
  a: function a(node, children) {
    return safeUrl(node.attribs.href, function () {
      return /*#__PURE__*/React.createElement(Link, pick(node.attribs, ['href', 'title', 'target']), children);
    }, function () {
      return /*#__PURE__*/React.createElement(Type, {
        inline: true
      }, children);
    });
  },
  sup: function sup(node, children) {
    return /*#__PURE__*/React.createElement(Type, {
      inline: true,
      className: classNames([style['nds-sup']])
    }, children);
  },
  '&reg;': function reg() {
    return '®';
  },
  '&copy;': function copy() {
    return '©';
  },
  '&#8480;': function _() {
    return '℠';
  },
  '&#x2120;': function x2120() {
    return '℠';
  },
  img: function img(node) {
    return safeUrl(node.attribs.src, function () {
      return /*#__PURE__*/React.createElement(Image, pick(node.attribs, ['src', 'title', 'alt', 'width', 'height']));
    }, function () {
      return get(node.attribs, 'alt', '') ? /*#__PURE__*/React.createElement(Type, {
        inline: true
      }, node.attribs.alt) : null;
    });
  },
  generic: function generic(node, children) {
    return /*#__PURE__*/React.createElement(Type, {
      inline: true,
      bold: node.name === 'strong' || node.name === 'b',
      italic: node.name === 'em' || node.name === 'i'
    }, children);
  }
};
export default NDSLib;